import { AUR } from "./aur";
import { SIMPLE_SUM } from "./simple-sum";
import { IMU_PERCENTAGE } from "./imu-percentage";
import { STORE_WITH_UNITS } from "./store-with-units";
import { AVERAGE_UNITS } from "./average-units";
import { UNIT_DOOR_PERCENTAGE_PLAN } from "./unit-door-percentage-plan";
import { DOOR_PERCENTAGE_PLAN } from "./door-percentage-plan";
import { AVERAGE_DEPTH } from "./average-depth";
import { AVERAGE_COST } from "./average-cost";

const totalsRowFormula = {
    UNITS: SIMPLE_SUM,
    AVERAGE_UNITS: AVERAGE_UNITS,
    STORE_WITH_UNITS: STORE_WITH_UNITS,
    TOTAL_COST: SIMPLE_SUM,
    TOTAL_RETAIL: SIMPLE_SUM,
    PLAN_ROWS: SIMPLE_SUM,
    IMU_PERCENTAGE: IMU_PERCENTAGE,
    AUR: AUR,
    UNIT_ROW_PERCENTAGE_PLAN: () => 100,
    ROW_PERCENTAGE_PLAN: () => 100,
    UNIT_DOOR_PERCENTAGE_PLAN: UNIT_DOOR_PERCENTAGE_PLAN,
    DOOR_PERCENTAGE_PLAN: DOOR_PERCENTAGE_PLAN,
    BREADTH_PERCENTAGE_PLAN: () => 100,
    AVERAGE_DEPTH,
    AVERAGE_COST,
};

export const getTotalsRowValue = ({ factoryOptions, getterParams }) => {
    const { metric } = factoryOptions;
    const formula = totalsRowFormula[metric.kind];
    const totalsValue = formula({ factoryOptions, getterParams });
    return totalsValue;
};
